export default {
  landingPage: {
    title: {
      fr: "SMARTHOME  •  SMARTBUILDING",
      en: "SMARTHOME  •  SMARTBUILDING",
    },
    subtitle: {
      fr: "La technologie qui vous comprend",
      en: "Technology built around you",
    },
    title1: {
      fr: "SMARTBUILDING",
      en: "SMARTBUILDING",
    },
    title2: {
      fr: "SMARTHOME",
      en: "SMARTHOME",
    },
    domain: {
      smarthome: {
        fr: "Offre\n<strong>Résidentiel</strong>",
        en: "Discover\n<strong>Residential</strong>",
      },
      smartbuilding: {
        fr: "Offre\n<strong>Tertiaire</strong>",
        en: "Discover\n<strong>Commercial</strong>",
      },
    },
  },
};
